module.exports = __webpack_public_path__ + "assets/img/3.775e8346.png";